module.exports = __webpack_public_path__ + "img/kanban03.e0630537.png";